// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: false,
  environment: 'LOCAL',
  baseUrl: 'https://report-api.emg.vn',
  //baseUrl: 'http://localhost:5006',
  queueUrl: 'https://qoms.sashi.vn',
  imageUrl: '',
  reportUrl: '',
  client_id: '3E46A49F-EE20-4A48-B29C-48B010026E1F',
  client_secret: '',
  LOG_LEVEL: NgxLoggerLevel.DEBUG,
  FBApi: {
    app_id: '330864987984549',
    app_secret: 'edee8b6751544a833dedd84cd20a25e2',
    version: 'v9.0',
    url: 'https://graph.facebook.com/',
  },
  VAPID_PUBLIC_KEY:
    'BJv9-hTnHCzkYdzg8jSMsm66Iw_6Y0i5MJoGOI0HAMnE6DpRD2CS_0FILpIW47fMqdNkYahkimpmfT2woLHNnCk',
  firebase: {
    apiKey: 'AIzaSyA3LUezavM0s6vitKlx1cDTr7jq0orN574',
    authDomain: 'sashi-b0d60.firebaseapp.com',
    projectId: 'sashi-b0d60',
    storageBucket: 'sashi-b0d60.appspot.com',
    messagingSenderId: '367782730165',
    appId: '1:367782730165:web:e9737fb19136c8e10c21fc',
    measurementId: 'G-MVWH4B5LTC',
  },
  shopee: {
    url: 'https://partner.test-stable.shopeemobile.com',
    partner_id: 1001934,
    partner_key:
      '98cded90f75119a9fc48986f3319021ece7d510d23e8f46fa0335b59fd743286',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
